import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cloud.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionAdminCloud.css';

const IntroSectionAdminCloud2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-admin-cloud-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('adminCloud.introSection.outsource.title', 'Externalisez la gestion')}</h2>
            <h3>{t('adminCloud.introSection.outsource.description', 'Confier votre administration système à IT Monkeys, c\'est bénéficier d\'administrateurs cloud certifiés, capables de résoudre vos problématiques et d\'anticiper vos besoins.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('adminCloud.introSection.videoNotSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('adminCloud.introSection.access.title', 'Gestions des rôles et accès')}</h2>
            <h3>{t('adminCloud.introSection.access.description', 'Avec l\'attribution des rôles selon le principe du moindre privilège et avec une surveillance continue, seuls les utilisateurs autorisés peuvent accéder à vos ressources.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('adminCloud.introSection.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('adminCloud.introSection.partner.title', 'Votre partenaire spécialisé')}</h2>
              <h3>{t('adminCloud.introSection.partner.description1', 'Nous maîtrisons les environnements cloud les plus complexes et assurons une gestion fluide et efficace de votre architecture cloud, quelle que soit sa taille.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('adminCloud.introSection.imageAlt', 'Admin Cloud')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionAdminCloud2;
